const CHART_TYPES = {
  CARD: 'card',
  TINY: 'tiny',
  GRAPH: 'graph',
  STACKED: 'stacked',
  STACKED_FEATURES: 'stackedfeatures',
  FIXED: 'fixed',
  TABLE: 'table',
  AREA: 'area',
  PIE: 'pie',
  WORLD_MAP: 'worldMap',
  COLUMN: 'column',
  BRAND_SITES: 'brand_sites',
  SCORE_RESPONDEES: 'SCORE_RESPONDEES',
  HEAT_TABLE: 'heattable',
  PIE_WITH_PRICE: 'PIE_WITH_PRICE',
  HEADER: 'header'
}

export default CHART_TYPES
